import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import InfiniteScroll from 'react-infinite-scroller';
import MediaItem from '../MediaItem';

const StyledInfiniteScroll = styled(InfiniteScroll)`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  padding: 50px;
`;

class ContentSimpleGrid extends React.Component {
  static propTypes = {
    // Handlers
    handleInfiniteLoad: PropTypes.func.isRequired,
    resetPageCounter: PropTypes.bool.isRequired,

    // Data
    landscapeCover: PropTypes.bool,
    currentLanguage: PropTypes.string.isRequired,
    itemRoute: PropTypes.string.isRequired,
    contentData: PropTypes.shape({
      status: PropTypes.number,
      pageLoaded: PropTypes.number,
      hasNext: PropTypes.bool,
      data: PropTypes.arrayOf(PropTypes.object),
    }).isRequired,
  }

  static defaultProps = {
    landscapeCover: false,
  }

  constructor(props) {
    super(props);

    const { resetPageCounter } = this.props;

    this.state = {
      resetPageCounter,
    };
  }

  componentDidMount() {
    const { contentData } = this.props;

    this.infiniteContainer.pageLoaded = contentData.pageLoaded;
  }

  componentDidUpdate() {
    const { resetPageCounter } = this.state;

    if (resetPageCounter) {
      this.infiniteContainer.pageLoaded = 0;
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.resetPageCounter !== prevState.resetPageCounter) {
      return {
        resetPageCounter: nextProps.resetPageCounter,
      };
    }
    return null;
  }

  render() {
    const {
      currentLanguage,
      contentData,
      itemRoute,
      handleInfiniteLoad,
      landscapeCover,
    } = this.props;

    return (
      <StyledInfiniteScroll
        ref={(infiniteContainer) => { this.infiniteContainer = infiniteContainer; }}
        loadMore={handleInfiniteLoad}
        hasMore={contentData.hasNext}
        threshold={200}
      >
        {
          contentData.data && contentData.data.map(item => (
            <MediaItem
              route={`${itemRoute}/${item.id}`}
              key={item.id}
              id={item.id}
              picture={item.picture}
              title={item.title}
              currentLanguage={currentLanguage}
              landscapeCover={landscapeCover}
              yearLimit={item.yearLimit}
            />
          ))
        }
      </StyledInfiniteScroll>
    );
  }
}

export default ContentSimpleGrid;
